'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface RecommendedGiftsSkeletonProps {
  className?: string;
}
export const RecommendedGiftsSkeleton = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-8", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center justify-between pr-20"><div className="ml-20 h-20 w-140 animate-pulse rounded-xxsmall bg-Gray-200" /><div className="h-16 w-40 animate-pulse rounded-xxsmall bg-Gray-200" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="scrollbar-hide flex gap-12 overflow-x-auto pb-24 pl-20">{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <section className={t1}>{t2}{t3}</section>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
function _temp(_, index) {
  return <div key={index} className="flex w-160 shrink-0 flex-col gap-8"><div className="aspect-square w-full animate-pulse rounded-xsmall bg-Gray-200" /><div className="h-16 w-full animate-pulse rounded-xxsmall bg-Gray-200" /><div className="h-14 w-80 animate-pulse rounded-xxsmall bg-Gray-200" /><div className="mt-4 h-40 w-full animate-pulse rounded-xsmall bg-Gray-200" /></div>;
}